import styles from "../css/ListCheckBoxButton.module.css";
import { ReactComponent as RadioAbled } from "../../../img/iconImgAllRadioAbled.svg";
import { ReactComponent as RadioDisabled } from "../../../img/iconImgAllRadioDisabled.svg";
import Divider from "../Divider";

interface ListCheckBoxButtonProps {
  id: number;
  title: string;
  checked: boolean;
  showingDivider?: boolean;
  onClick: () => void;
}

export default function ListCheckBoxButton(props: ListCheckBoxButtonProps) {
  return (
    <>
      <div className={styles.container} onClick={props.onClick}>
        <span className={styles.titleText}>{props.title}</span>
        {props.checked && (
          <RadioAbled
            className={styles.checkBoxAbled}
            style={{
              color: "var(--control-active-color)",
            }}
          />
        )}
        {!props.checked && (
          <RadioDisabled
            className={styles.checkBoxDisabled}
            style={{
              color: "var(--control-default-color)",
            }}
          />
        )}
      </div>
      {props.showingDivider !== undefined && props.showingDivider && (
        <Divider />
      )}
    </>
  );
}
